import { createStore, applyMiddleware, compose } from 'redux';
import { thunk as thunkMiddleware } from 'redux-thunk'; 
import rootReducer from './reducers/reducers';

export function configureStore(preloadedState) {
    const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

    return createStore(
        rootReducer,
        preloadedState,
        composeEnhancers(
            applyMiddleware(thunkMiddleware)
        )
    );
}